export const layoutTokens = {
  tableOffset: '135px',
  sidebarExpanded: '240px',
  sidebarCollapsed: '64px',
} as const;
